import NewReadingGoalModal from './NewReadingGoalModal'

export default NewReadingGoalModal
